module.exports = __webpack_public_path__ + "img/info_icon.2961191b.svg";